import { z } from "zod";
//#region src/api/orpc/util/success.ts
const orpcSuccessVoidResponseSchema = z.object({ success: z.literal(true) });
//#endregion
export { orpcSuccessVoidResponseSchema };
